import { Node } from "@iventis/domain-model/model/node";
import { GetInteractivity, NodeComponent, TreeBrowserGridVirtualScrollingComponent } from "@iventis/tree-browser";
import { tileViewGap, styled } from "@iventis/styles";
import React, { FunctionComponent } from "react";
import { LibraryNodeExtraProps } from "./library-nodes";

export const GALLERY_NODE_CONTENT_CLASS_NAME = "gallery-node-content";

const TILE_HEIGHT = 242;

export const LibraryGalleryView: FunctionComponent<{
    tree: Node;
    components: { [key: string]: NodeComponent<Node, LibraryNodeExtraProps> };
    extraProps: LibraryNodeExtraProps;
    getInteractivity?: GetInteractivity<Node>;
}> = ({ tree, components, extraProps, getInteractivity }) => (
    <TreeBrowserGridVirtualScrollingComponent
        nodes={tree.childNodes}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        listComponent={LibraryStyledGrid as any} // Fix later
        components={components}
        getInteractivity={getInteractivity}
        extraProps={{ ...extraProps, contentClassName: GALLERY_NODE_CONTENT_CLASS_NAME }}
        overscan={TILE_HEIGHT}
    />
);

export const LibraryStyledGrid = styled.div`
    display: flex;
    grid-template-rows: auto;
    width: 100%;
    gap: ${tileViewGap};
    position: relative;
    box-sizing: border-box;
    // Can't use padding to set gap at top and bottom as it breaks virtual scrolling
    margin: ${tileViewGap} 0px;
    padding: 0px ${tileViewGap};
    flex-wrap: wrap;
`;
